var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"course-form-terms-box form-page-terms-box"},[_c('h2',{staticClass:"title is-5 is-size-6-mobile has-text-secondary has-text-weight-bold"},[_vm._v("ワーカーズフォーラムＭＯＣ　サービスご利用規約")]),_c('KiyakuContents')],1)}
var staticRenderFns = []

export { render, staticRenderFns }